module.exports = __webpack_public_path__ + "static/media/kamil.b9366655.jpg";